
import { selectScheduleConstants } from "../../actionTypes";

const getSelectScheduleData = (payload: any) => {
  return (dispatch: any) => {
    dispatch({ type: selectScheduleConstants.GET_SELECT_SCHEDULE_DATA, payload });
  };
}


export const selectScheduleActions = {
 getSelectScheduleData,
};